const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const target = entry.target;
            const numberEl = target.querySelector('dt [data-number]');
            const number = parseInt(target.querySelector('dt [data-number]').innerText);
            const startingNumber = 0;
            const duration = 800;
            let currentNumber = startingNumber;
            const increment = number / (duration / 10);
            const interval = setInterval(() => {
                currentNumber += increment;
                if (currentNumber >= number) {
                    clearInterval(interval);
                    currentNumber = number;
                }

                numberEl.innerText = Math.floor(currentNumber);
            }, 10);
            observer.unobserve(target);
        }
    });
});

const targets = document.querySelectorAll('.card__stat-card');

targets.forEach(target => {
    observer.observe(target);
});